import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { JourneyComponent } from '@app/features/journey.component';
import { ProfileComponent } from '@app/features/profile/profile.component';
import { CoverageComponent } from '@app/features/coverage/coverage.component';
import { SaveComponent } from '@app/features/save/save.component';
import { MyFinancialComponent } from '@app/features/my-financial/my-financial.component';
import { MyLifestyleComponent } from '@app/features/my-lifestyle/my-lifestyle.component';
import { MyNeedsComponent } from '@app/features/my-needs/needs.component';
import {
  ProfileRouteGuard, CoverageRouteGuard,
  SaveRouteGuard, EmailRequiredGuard, ReferralCodeGuard, MyFinancialRouteGuard, NeedsRouteGuard
} from '@app/shared/common/route-guard';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { Error404Component } from './error404/error404.component';

export const routes: Routes = [
  { path: ':tenant/home', component: HomeComponent },
  { path: '', redirectTo: 'wellnex/home', pathMatch: 'full' },

  {
    path: ':tenant/journey', component: JourneyComponent,
    children: [
      { path: '', redirectTo: 'profile', pathMatch: 'full' },
      { path: 'profile', component: ProfileComponent, canActivate: [ReferralCodeGuard] },
      { path: 'coverage', component: CoverageComponent, canActivate: [ReferralCodeGuard, ProfileRouteGuard] },
      { path: 'my-needs', component: MyNeedsComponent, canActivate: [ReferralCodeGuard, CoverageRouteGuard] },
      { path: 'my-financial', component: MyFinancialComponent, canActivate: [ReferralCodeGuard, NeedsRouteGuard] },
      { path: 'my-lifestyle', component: MyLifestyleComponent, canActivate: [ReferralCodeGuard, MyFinancialRouteGuard] },
      { path: 'submit', component: SaveComponent, canActivate: [ReferralCodeGuard, EmailRequiredGuard] },
      { path: 'thank-you', component: ThankYouComponent, canActivate: [ReferralCodeGuard, SaveRouteGuard] }
    ]
  },
  { path: '**', component: Error404Component },
];




// WEBPACK FOOTER //
// ./src/app/features/feature.routing.ts